module.exports = __webpack_public_path__ + "media/night/122-c4ba85f5.svg";